import { type schemaType } from '~~/shared/api/strapi/how-platform-works-page/schema'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/strapi/how-platform-works-page`

  const { data } = await useFetch(url, {
    method: 'POST',
    key: url,
  })

  return data.value as returnType
}

export const browserFetch = async (): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/strapi/how-platform-works-page`

  const data = await $fetch(url, {
    method: 'POST',
  })

  return data as returnType
}
